exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".login-padding {\n  padding-top: 30px; }\n\n.main-card-padding {\n  margin: 0 auto;\n  width: 100%;\n  height: 100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center; }\n\n.result-card {\n  margin-bottom: 5px; }\n\n.card-width {\n  width: 100%;\n  max-width: 600px;\n  background-color: #ffffff; }\n\n.click-cursor {\n  cursor: pointer; }\n\n.clip-name {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis; }\n\n.unclicked-consensus {\n  font-size: xx-large;\n  display: block;\n  text-align: center;\n  color: black; }\n\n.item-divider {\n  margin-bottom: 10px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /agir/src/app/components/planning-poker-home/planning-poker-home.component.scss
// module id = ../../../../../src/app/components/planning-poker-home/planning-poker-home.component.scss
// module chunks = main